export default __webpack_public_path__ + "static/media/CN_Card_Red.275ce18a.png";